export default {
  data: function () {
    return {
      isPinned: false,
      isLoading: false
    }
  },
  mounted: function () {
    this.pinnedProjects && this.checkPinnedProjects()
  },
  watch: {
    pinnedProjects: function () {
      this.checkPinnedProjects()
    }
  },
  computed: {
    showPin: function () {
      const canPin = this.isAdmin && this.isPinnableRow
      const alreadyPinned = this.isPinned
      return canPin || alreadyPinned
    }
  },
  methods: {
    checkPinnedProjects: function () {
      this.isPinned = this.pinnedProjects?.includes(this.projectID)
    },
    handlePinnedProject: async function () {
      if (!this.isAdmin) {
        return
      }
      this.togglePinnedProject()
      this.toggleLoader()
      await this.setPinnedProject()
      this.updateProjectRow()
    },
    togglePinnedProject: function () {
      this.isPinned = !this.isPinned
    },
    setPinnedProject: async function () {
      const data = {
        projectID: this.projectID,
        categoryID: this.categoryID,
        isPinned: this.isPinned
      }
      await this.$store.dispatch('updateProjectPinned', data)
    },
    updateProjectRow: function () {
      this.$emit('onPinned', this.isPinned)
      this.toggleLoader()
    },
    toggleLoader: function () {
      this.isLoading = !this.isLoading
    }
  }
}
